import React, { createContext, useState, useEffect } from 'react';
import { fetchSearchOptions } from '../helpers/fetchSearchOptions';
import axios from 'axios';

export const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const [map, setMap] = useState('');
  const [config, setConfig] = useState(null);
  const [mapKey, setMapKey] = useState(1);
  const [mapLayer, setMapLayer] = useState('');
  const [mapLegendData, setMapLegendData] = useState('');
  const [mapData, setMapData] = useState({ label: "", varible: "", type: "", style: "" });
  const [zoom, setZoom] = useState(7);
  const [center, setCenter] = useState([-1.831239, -78.183406]);
  const [geom, setGeom] = useState('');
  // const [loadMapOption, setLoadMapOption] = useState('');  
  const [globalLoading, setGlobalLoading] = useState(true);  
  // const [provincia, setProvincia] = useState('');  
  const [canton, setCanton] = useState('');  

  useEffect(() => {
    const fetchConfig = async () => {
      const response = await axios.get('./config.json');
      setConfig(response.data);
    };
    fetchConfig();
  }, []);

  useEffect( () => {
    if (config) {
      fetchSearchOptions( 
        config.map.geoserverUrl, 
        'GyL_PorCanton_Emisiones_Percapita_2023', 
        'dpa_descan' 
      ).then( data => {
        setCanton(data);
      })}}, [config])

  // useEffect( () => {
  //   if (config) {
  //     fetchSearchOptions( 
  //       config.map.geoserverUrl, 
  //       'limites_provinciales', 
  //       'dpa_despro' 
  //     ).then( data => {
  //       setProvincia(data);
  //     })}}, [config])

useEffect( () => {
  if (canton) {
    setGlobalLoading(false)
}
}, [canton])

  return (
    <AppContext.Provider value={{
      map, setMap,
      config, setConfig,
      mapKey, setMapKey,
      mapLayer, setMapLayer,
      mapLegendData, setMapLegendData,
      mapData, setMapData,
      zoom, setZoom,
      center, setCenter,
      geom, setGeom,
      // loadMapOption, setLoadMapOption,
      globalLoading, setGlobalLoading,
      canton, setCanton,
    }}>
      {children}
    </AppContext.Provider>
  );
};
